import { render } from "./ExamCreateView.vue?vue&type=template&id=56e6c341&scoped=true"
import script from "./ExamCreateView.vue?vue&type=script&lang=js"
export * from "./ExamCreateView.vue?vue&type=script&lang=js"

import "./ExamCreateView.vue?vue&type=style&index=0&id=56e6c341&scoped=true&lang=css"

import exportComponent from "../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-56e6c341"]])

export default __exports__